import { RiskType } from "@wallet-manager/node-types/dist/src/postgres/const";
import { useTranslation } from "src/hooks";
import { NodeTypesEnumSingleSelection } from "./GeneralSelection";
import { SelectChangeEvent } from "./MuiGenerals";

interface IProps {
  label?: string;
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
  onClearSelect: () => void;
}

const RiskTypeSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClearSelect } = props;
  const { t, te, translate } = useTranslation("common");
  return (
    <NodeTypesEnumSingleSelection
      label={label ?? t("phSelection", { fieldName: te("RiskType") })}
      onChange={onChange}
      value={value}
      enumData={RiskType}
      nameFn={(name) => translate(`enumRiskType.${name}`)}
      isNoSorting
      clearSelect={onClearSelect}
    />
  );
};

export default RiskTypeSingleSelection;
